import {arrayGenerate, Nullable, numberRandomInRange, valueConvertWhenNotNullable} from "@wix/devzai-utils-common";

export function wixRequestIdGenerate () {
    return Date.now().toString().substring(0, 10) + '.' + arrayGenerate(19, () => numberRandomInRange(0, 9)).join('')
}

export function wixRequestIdValidOrDefault<T = undefined> (requestId: Nullable<string>, defaultValue?: T) {
    return valueConvertWhenNotNullable(requestId, requestId => {
        return requestId.includes('.') ? requestId : undefined
    }) ?? defaultValue;
}

export const WixRequestIdHeaderName = 'x-wix-request-id';